import { render, staticRenderFns } from "./SessionCard.vue?vue&type=template&id=10dd184a&scoped=true"
import script from "./SessionCard.vue?vue&type=script&lang=js"
export * from "./SessionCard.vue?vue&type=script&lang=js"
import style0 from "./SessionCard.vue?vue&type=style&index=0&id=10dd184a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dd184a",
  null
  
)

export default component.exports